export default () => {
  if (!customElements.get("what-is-in-the-box")) {
    customElements.define("what-is-in-the-box", class ProductFaq extends HTMLElement {
      constructor() {
        super()

        this.currentVariantId = this.dataset.currentVariantId

        // PC端最多显示4个，下标为3
        this.INIT_COLUMN_INDEX = 3
        this.tableContainer = this.querySelector(".table-container")
        this.leftArrow = this.querySelector(".table-left-arrow")
        this.rightArrow = this.querySelector(".table-right-arrow")
        this.currentIndex = this.INIT_COLUMN_INDEX

        const skuJsonString = this.querySelector('#variant-what-in-box-4-0')?.innerText || '[]'
        const spuJsonString = this.querySelector('#product-what-in-box-4-0')?.innerText || '[]'
        this.skuData = JSON.parse(skuJsonString)
        this.spuData = JSON.parse(spuJsonString)

        // 扁平化数据，得到加电包配置的所有数据列
        this.allData = this.spuData.map(({ skuId, list }) => list.map(({img, name}) => {
          const [title, quantity] = name.split('*')
          return {
            skuId,
            img,
            name: title?.trim(),
            quantity: quantity?.trim()
          }
        })).flat()

        // 总变体数量
        this.totalSkuLength = this.skuData.length

        this.init()
      }
      init() {
        const whatsBox = document.querySelector(".accordion--whats-in-box")
        const isOnly = this.hasAttribute("only-default-variant")
        // 只有配置了数据才初始化
        if (this.allData.length > 0) {
          whatsBox && !isOnly && whatsBox.classList.remove("hidden")

          this.initPC()
          this.initMobile()

          // 监听变体切换
          document.addEventListener('variantChangeEvent', e => {
            const currentVariant = e.detail.variant
            if (currentVariant) {
              this.variantAutoScroll(currentVariant.id)

              if (this.mobileSkuBox) {
                // 更新 sku 图片
                const curTarget = this.skuData.find(item => item.skuId == currentVariant.id)
                curTarget && (this.mobileSkuBox.querySelector('.sku-img').src = curTarget.img)

                // 更新 配件显示
                this.mobileSkuBox.querySelectorAll('.sku-wrap[data-sku-id]').forEach(t => t.style.display = 'none')
                this.mobileSkuBox.querySelector(`.sku-wrap[data-sku-id="${currentVariant.id}"]`).style.display = 'flex'

                // 更新 select 显示
                this.mobileSkuBox.querySelector('select').value = currentVariant.id
              }
            }
          })
        } else { // 无数据 - 整个whats in box不显示
          whatsBox && !isOnly && whatsBox.classList.add("hidden")
        }
      }
      // Mobile 端切换
      initMobile() {
        this.mobileSkuBox = this.querySelector('.sku-box-wrap')
        this.mobileSkuBox.querySelector('select').addEventListener('change', (e) => {
          const selectedIndex = e.target.selectedIndex || 0
          const skuId = e.target.options[selectedIndex].value

          // 更新 sku 图片
          const curTarget = this.skuData.find(item => item.skuId == skuId)
          curTarget && (this.mobileSkuBox.querySelector('.sku-img').src = curTarget.img)

          // 更新 配件显示
          this.mobileSkuBox.querySelectorAll('.sku-wrap[data-sku-id]').forEach(t => t.style.display = 'none')
          this.mobileSkuBox.querySelector(`.sku-wrap[data-sku-id="${skuId}"]`).style.display = 'flex'
        })
      }
      // PC 端
      initPC() {
        const theadData = [null, ...this.skuData]

        // 数据分组
        const groupedData = this.allData.reduce((arr, item) => {
          // 如果分组对象中不存在该 name，则创建一个新数组
          if (!arr[item.name]) {
            arr[item.name] = []
          }
          // 将对象添加到对应 name 的数组中
          arr[item.name].push(item)
          return arr
        }, {})

        // 数组去重
        const uniqueData = [...new Map(this.allData.map(item => [item.name, item])).values()]

        const tbodyData = uniqueData.map(({ img, name, }) => {
          const rowSku = groupedData[name]
          const length = Math.max(this.totalSkuLength - rowSku.length, 0)
          const data = rowSku.concat(Array(length).fill(null))
          return { img, name, data }
        })
        this.renderTable(theadData, tbodyData)
      }
      renderTable(theadData, tbodyData) {
        // 创建表格
        let tableHTML = "<table><thead><tr>"
        
        // 获取并添加表头
        theadData.forEach((item, index) => {
          tableHTML += index === 0 ? `<th></th>` : `
            <th data-sku-id="${item?.skuId}">
              <div>
                <img src="${item?.img}" alt="" loading="lazy">
                <h4 title="${item?.name}">${item?.name}</h4>
              </div>
            </th>
          `
        })
        tableHTML += "</tr></thead><tbody>"
        
        // 添加数据行
        tbodyData.forEach(item => {
          tableHTML += '<tr>'
          theadData.forEach((header, index) => {
            const quantity = item.data.find(row => header?.skuId == row?.skuId)?.quantity
            tableHTML += index === 0 ? `
              <td>
                <div>
                  <img src="${item?.img}" alt="" loading="lazy">
                  <span title="${item?.name}">${item?.name}</span>
                </div>
              </td>
            ` : `<td data-sku-id="${header?.skuId}"><div>${quantity ? `X${quantity}` : '-'}</div></td>`
          })
          tableHTML += '</tr>'
        })
        
        tableHTML += "</tbody></table>"
        this.tableContainer.innerHTML = tableHTML
        this.initTable()
      }
      initTable() {
        this.table = this.tableContainer.querySelector('table')

        this.tableCell = []
        for (let row of this.table.rows) {
          for (let cell of row.cells) {
            if (row.rowIndex === 0 && cell.cellIndex !== 0) {
              this.tableCell.push(cell.getBoundingClientRect().width)
            }
          }
        }

        this.variantAutoScroll(this.currentVariantId)

        // 变体数量超过 4 个，才显示左右箭头
        if (this.totalSkuLength > 4) {
          this.initTableArrowEvent()
        }
      }
      // 高亮当前变体列
      initTableHighlight(variantId) {
        if (!variantId) return
        // 移除全部
        this.table.querySelectorAll('[data-sku-id]').forEach(t => t.classList.remove('active-column'))
        this.table.querySelectorAll(`[data-sku-id="${variantId}"]`).forEach(t => t.classList.add('active-column'))
      }
      // 左右箭头
      initTableArrowEvent() {
        this.leftArrow.parentElement.style.display = 'flex'

        // 左箭头
        this.leftArrow.onclick = (e) => {
          this.currentIndex = Math.max(this.INIT_COLUMN_INDEX, this.currentIndex - 1)
          const scrollXWidth = Math.max(0, this.tableContainer.scrollLeft - this.tableCell[this.currentIndex])
          this.tableContainer.scrollTo({
            left: scrollXWidth,
            behavior: "smooth"
          })
          this.rightArrow.removeAttribute("disabled")
          if (this.currentIndex === this.INIT_COLUMN_INDEX) {
            this.leftArrow.setAttribute("disabled", "disabled")
          }
        }

        // 右箭头
        this.rightArrow.onclick = (e) => {
          this.currentIndex = Math.min(this.totalSkuLength - 1, this.currentIndex + 1)
          const scrollXWidth = this.tableCell[this.currentIndex] * (this.currentIndex - this.INIT_COLUMN_INDEX)
          this.tableContainer.scrollTo({
            left: scrollXWidth,
            behavior: "smooth"
          })
          this.leftArrow.removeAttribute("disabled")
          if (this.currentIndex === this.totalSkuLength - 1) {
            this.rightArrow.setAttribute("disabled", "disabled")
          }
        }
      }

      // 切换变体，自动滚动到对应位置并高亮
      variantAutoScroll(variantId) {
        // 高亮当前sku
        this.initTableHighlight(variantId)

        // 变体数量超过 4 个，才自动滚动
        if (this.totalSkuLength > 4) {
          // 当前变体索引
          const index = this.skuData.findIndex(item => item.skuId == variantId)

          // 索引间隔
          const indexGap = Math.max(0, index - this.INIT_COLUMN_INDEX)

          // 需要滚动的距离（已考虑不等宽的情况）
          const scrollXWidth = indexGap === 0 ? 0 : this.tableCell.slice(4, index + 1).reduce((prev, next) => prev += next, 0)

          this.tableContainer.scrollTo({
            left: scrollXWidth,
            behavior: "smooth"
          })

          // 更新按钮状态
          if (scrollXWidth > 0) {
            this.leftArrow.removeAttribute("disabled")
            if (index === this.totalSkuLength - 1) {
              this.rightArrow.setAttribute("disabled", "disabled")
            } else {
              this.rightArrow.removeAttribute("disabled")
            }
          } else {
            this.leftArrow.setAttribute("disabled", "disabled")
            this.rightArrow.removeAttribute("disabled")
          }
        }
      }
    })
  }
}
